module.exports = __webpack_public_path__ + "static/media/invoice_icon.05dbba95.svg";